import { render, staticRenderFns } from "./staffModal.vue?vue&type=template&id=c3ad3a76&scoped=true"
import script from "./staffModal.vue?vue&type=script&lang=js"
export * from "./staffModal.vue?vue&type=script&lang=js"
import style0 from "./staffModal.vue?vue&type=style&index=0&id=c3ad3a76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ad3a76",
  null
  
)

export default component.exports